import AdvancedTable from '@/advanced-table/AdvancedTable.vue'
import {registerRoute} from '@/router'

const ADVANCED_TABLE = {componentName: 'AdvancedTable', component: AdvancedTable, meta: {requiresOrg: true}}

registerRoute(ADVANCED_TABLE)